export default {"src":"/_next/static/media/hand-heart.a905fcf6.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};